export const base = '/search/:entity/:hash/*';